import { render, staticRenderFns } from "./add-project.vue?vue&type=template&id=1a18783e"
import script from "./add-project.vue?vue&type=script&lang=js"
export * from "./add-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports